
import { defineComponent } from "vue";
import OrderHeaderChangeActions from "@/components/OrderHeaderChangeActions.vue";
import SelectPriceTypeComponent from "@/components/SelectPriceTypeComponent.vue";
import BackAndCancelFooter from "@/components/BackAndCancelFooter.vue";
import ViewHeader from "@/components/ViewHeader.vue";

export default defineComponent({
  components: {
    OrderHeaderChangeActions,
    SelectPriceTypeComponent,
    BackAndCancelFooter,
    ViewHeader,
  },
  async setup() {
    return {};
  },
});
